import ResultsBar from './ResultsBar';
export default ResultsBar;